module.exports = __webpack_public_path__ + "img/revelations.4c0e7b1a.svg";